import { fKeyTabInput } from "../../../Utility/Utilitys";
import {
  CmpTextField,
  CmpTextFieldEnter,
  CmpSelectBox,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import { BarcodeFlag } from "../EasyPutAwayAction";
import { Button } from "@mui/material";
export default function WmsContent({
  sEnterKeyObj,
  vMediaQuery,
  xContent_Focus,
  xContent_Blur,
  xErrorMsgDetail,

  xBufferObj,
  sUnit,

  fUnit,
  fQty,
  fReason,
  fQty_Enter,
  fCardId,
  fCardIdEnter,
  fB_PalletId,
  fB_PalletIdEnter,
  fBarcode,
  fBarcodeEnter,
  fItemName,
  vRdxHead,
  sReasonArr,
  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,

  //customer
  xfGC_Toggle_Head_BinName_Name,
  xGC_Toggle_Head_BinName_Toggle = false,
  xGC_Toggle_Head_BinName_onKeyUp,
  xGC_Toggle_Head_BinName_SearchDropdownObj,
  xGC_Toggle_Head_BinName_Dropdown_onChange,
  xGC_Toggle_Head_BinName_Dropdown_OnKeyUp_Load,
  xGC_Toggle_Head_BinName_GridColumns,
  xGC_Toggle_Head_BinName_GridData,
  xfGC_Toggle_Head_BinName_OnRowClick,
  xfGC_Toggle_Head_BinName_OnCellKeyDown,
  xGC_Toggle_Head_BinName_DropDown_Arr,
  //customer end
}) {
  const buttonStyleBin = {
    background: 'orange',
    borderRadius: '20px',
    padding: '1px 17px',
    color: 'white', 
    textTransform: 'none',    
   minWidth:'-webkit-fill-available' 
    // '@media (max-width: 768px)': { // Adjust the max-width as per your mobile screen size
    //   fontSize: '10px !important'// Set the font size for mobile screens
    // }
  };
  const buttonStyleRef = {
    background: 'red',
    borderRadius: '20px',
    padding: '1px 17px',
    color: 'white', 
    textTransform: 'none',    
   minWidth:'-webkit-fill-available' 
    // '@media (max-width: 768px)': { // Adjust the max-width as per your mobile screen size
    //   fontSize: '10px !important'// Set the font size for mobile screens
    // }
  };
  return (
    <form
      className="Wms-inbound-grn-content mt-4"
      id="WmsStockAdjustmentContent"
    >
      <Grid
        container
        spacing={0}
        columns={{ xs: 12, sm: 12, md: 12 }}
        className="mb-1 justify-content-between buttonstyle"
      >
        <Grid item xs={"auto"} sm={"auto"} md={"auto"} >
          {/* <CmpTypographyField
            xcomponent={"span"}
            xText={"RefNo=" + xBufferObj.SuppRefNo1}            
          />  */}
          <Button size="small"  style={buttonStyleRef}>RefNo &nbsp;  &nbsp; { xBufferObj.SuppRefNo1}</Button>
        </Grid>
        <Grid item xs={"auto"} sm={"auto"} md={"auto"}>
          {/* <CmpTypographyField
            xcomponent={"span"}
            xText={"Sugg_Bin=" + vRdxHead.SuggBin}
          /> */}
            <Button    style={buttonStyleBin}>Sugg_Bin  &nbsp;  &nbsp;{ vRdxHead.SuggBin}</Button>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={{ xs: 0.9, sm: 1, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Sr.No"}
            xVariant={"standard"}
            xValue={xBufferObj.B_Srno}
            xType={"text"} // text/number/password
            xName={"B_Srno"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Srno === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Srno}
          />
        </Grid>
       
        <Grid item xs={8} md={BarcodeFlag() ? 8 : 8}>
          <CmpTextFieldEnter
            xLabelText={"Pallet ID" }
            xVariant={"standard"}
            xValue={xBufferObj.B_PalletId}
            xType={"text"} // text/number/password
            xName={"B_PalletId"}
            xReadOnly={false}
            xOnChange={fB_PalletId}
            xError={xErrorMsgDetail.B_PalletId === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_PalletId}
            xtabIndex={"101"}
            xOnKeyUp={fB_PalletIdEnter}
            xOnEnter={(e) => {
              fB_PalletIdEnter(sEnterKeyObj);
            }}
            xSmShow={!!vMediaQuery}
          />
        </Grid>
        <Grid item xs={4} md={BarcodeFlag() ? 4 : 4}>
        <CmpTextField
              xLabelText={"Card ID"}
              xVariant={"standard"}
              xValue={xBufferObj.B_CardId}
              xType={"text"} // text/number/password
              xName={"B_CardId"}
              xReadOnly={true}
              xOnChange={fCardId}
              xError={xErrorMsgDetail.B_CardId === "" ? false : true}
              xErrorMessage={xErrorMsgDetail.B_CardId}
          />
          {/* <CmpTextFieldEnter
            xLabelText={"Card ID"}
            xVariant={"standard"}
            xValue={xBufferObj.B_CardId}
            xType={"text"} // text/number/password
            xName={"B_CardId"}
            xReadOnly={true}
            xOnChange={fCardId}
            xError={xErrorMsgDetail.B_CardId === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_CardId}
            xtabIndex={"101"}
            xOnKeyUp={fCardIdEnter}
            xOnEnter={(e) => {
              fCardIdEnter(sEnterKeyObj);
            }}
            xSmShow={!!vMediaQuery}
          /> */}
        </Grid>
       
        <Grid
          item
          xs={8}
          md={8}
          className={BarcodeFlag() ? "" : "hide-all-time"}
        >
          <CmpTextFieldEnter
            xLabelText={"Barcode"}
            xVariant={"standard"}
            xValue={xBufferObj.B_Barcode}
            xType={"text"} // text/number/password
            xName={"B_Barcode"}
            xReadOnly={false}
            xOnChange={fBarcode}
            xError={xErrorMsgDetail.B_Barcode === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Barcode}
            xtabIndex={"101"}
            xOnKeyUp={fBarcodeEnter}
            xOnEnter={(e) => {
              fBarcodeEnter(sEnterKeyObj);
            }}
            xSmShow={!!vMediaQuery}
          />
        </Grid>
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Item Code"}
            xVariant={"standard"}
            xValue={xBufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Itmcd === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Itmcd}
          />
        </Grid>
        <Grid item xs={8}>
          <CmpTextField
            xLabelText={"Item Name"}
            xVariant={"standard"}
            xValue={xBufferObj?.B_ItmName}
            xOnChange={fItemName}
            xReadOnly={true}
            xType={"text"}
            xName={"B_ItmName"}
            xError={xErrorMsgDetail.B_ItmName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ItmName}
            xtabIndex={"102"}
          />
        </Grid>
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Bin No"}
            xVariant={"standard"}
            xValue={xBufferObj.B_BinCode}
            xType={"text"} // text/number/password
            xName={"B_BinCode"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BinCode === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BinCode}
          />
        </Grid>
        <Grid item xs={8}>
          <CmpTextFieldEnter
            xtabIndex="103"
            xLabelText={"Bin Name"}
            xVariant={"standard"}
            xValue={xBufferObj.B_BinName}
            xOnChange={xfGC_Toggle_Head_BinName_Name}
            xOnKeyUp={xGC_Toggle_Head_BinName_onKeyUp}
            xReadOnly={false}
            xType={"text"}
            xName={"GC_Toggle_Head_BinName_Name"}
            xError={xErrorMsgDetail.B_BinName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BinName}
            xOnEnter={(e) => {
              xGC_Toggle_Head_BinName_onKeyUp(sEnterKeyObj);
            }}
            xSmShow={!!vMediaQuery}
          />
        </Grid>
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Qty"}
            xVariant={"standard"}
            xtabIndex={"104"}
            xValue={xBufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={true}
            xOnChange={fQty}
            xError={xErrorMsgDetail.B_Qty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Qty}
            xOnKeyUp={fQty_Enter}
            xonFocus={(e) => {
              xContent_Focus(e);
            }}
            xonBlur={xContent_Blur}
          />
        </Grid>
       
        <Grid item xs={6}>
          <CmpSelectBox
            xtabIndex={"105"}
            xLabelText="Unit"
            xVariant={"standard"}
            xValue={xBufferObj.B_Unit}
            xOnChange={fUnit}
            xName={"unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_Unit === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Unit}
            xDisable={false}
          />
        </Grid>
        {/* <Grid item xs={2}>
          <CmpTextField
            xLabelText={"Packing"}
            xVariant={"standard"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_Packing}
            xType={"text"} // text/number/password
            xName={"B_Packing"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Packing === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Packing}
          />
        </Grid> */}
        <Grid item xs={2}>
          <CmpTextField
            xLabelText={"Base Qty"}
            xVariant={"standard"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_BaseQty}
            xType={"text"} // text/number/password
            xName={"B_BaseQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BaseQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BaseQty}
          />
        </Grid>
        {/* <Grid item xs={2}>
          <CmpTextField
            xLabelText={"BatchNo"}
            xVariant={"standard"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_BatchNo}
            xType={"text"} // text/number/password
            xName={"B_BatchNo"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BatchNo === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BatchNo}
          />
        </Grid> */}
        
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"GRN Qty"}
            xVariant={"standard"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_GrnQty}
            xType={"text"} // text/number/password
            xName={"B_GrnQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_GrnQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_GrnQty}
          />
        </Grid>
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"PutAway Qty"}
            xVariant={"standard"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_PutAwayQty}
            xType={"text"} // text/number/password
            xName={"B_PutAwayQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_PutAwayQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_PutAwayQty}
          />
        </Grid>
        <Grid item xs={4}>
          <CmpTextField
            xLabelText={"Balance Qty"}
            xVariant={"standard"}
            xtabIndex={"107"}
            xValue={xBufferObj.B_BalanceQty}
            xType={"text"} // text/number/password
            xName={"B_BalanceQty"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_BalanceQty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_BalanceQty}
          />
        </Grid>
        <Grid item xs={12}>
          {/* <CmpTextField
            xLabelText={"Reason"}
            xVariant={"standard"}
            xtabIndex={"104"}
            xValue={xBufferObj.Reason}
            xType={"number"} // text/number/password
            xName={"Reason"}
            xReadOnly={false}
            xOnChange={fReason}
            xError={xErrorMsgDetail.Reason === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.Reason} 
            xonBlur={xContent_Blur}
          /> */}
           <CmpSelectBox
            xtabIndex={"105"}
            xLabelText="Reason"
            xVariant={"standard"}
            xValue={xBufferObj.Reason}
            xOnChange={fReason}
            xName={"Reason"}
            xData={sReasonArr}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.Reason === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.Reason}
            xDisable={false}
          />
        </Grid>
      </Grid>
    </form>
  );
}
